"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDidUpdate = void 0;
var react_1 = require("react");
function useDidUpdate(fn) {
    react_1.useEffect(fn);
}
exports.useDidUpdate = useDidUpdate;
